import React from 'react'
import './statusLabel.scss'
import { capitalize } from 'lodash'
import { t } from 'translations'

export const getMembershipStatusLabel = (status: string) => {
    switch (status) {
        case 'active':
            return t('memberships.membershipsTable.status.active')
        case 'inactive':
            return t('memberships.membershipsTable.status.inactive')
        case 'overdue':
            return t('memberships.membershipsTable.status.overdue')
        default:
            return capitalize(status)
    }
}

interface StatusLabelProps {
    status: string
}

const StatusLabel: React.FC<StatusLabelProps> = ({ status }) => {
    return <div className={`status-label ${status}`}>{getMembershipStatusLabel(status)}</div>
}

export default StatusLabel
